import React, { useMemo } from 'react';
import { AdContext } from './AdContext';
/**
 * Wrapper is used to give SSR access to rendered ads
 */ const AdWrapper = ({ children, DaAds })=>{
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const DaAdsMemo = useMemo(()=>({
            DaAds
        }), []);
    return /*#__PURE__*/ React.createElement(AdContext.Provider, {
        value: DaAdsMemo
    }, children);
};
AdWrapper.displayName = 'AdWrapper';
export default AdWrapper;
